export const multiBusinessModule = {
  namespaced: true,
  state: {
    data: {
      isMultiBusinessFlow: false,
      hasSoleProprietor: false,
      allowEditingPersonalDetails: true,
    },
  },
  mutations: {
    setKeyValue(state, payload) {
      let { prop, value } = payload
      state.data = { ...state.data, [prop]: value }
    },
    setMultiKeyValues(state, payload) {
      state.data = { ...state.data, ...payload }
    },
  },
  getters: {
    data({ data }) {
      return { ...data }
    },
  },
}



// WEBPACK FOOTER //
// ./src/RF_store/modules/multiBusiness.module.js